import { ReactNode } from "react";

import { Language } from "../../../../../../services";
import { getDefaultColumnLabelCellHelpers } from "../../../../../../utils";
import {
	ColumnId,
	translationTablePath,
	translationTablePath2,
	defaultColumns,
} from "../../../../../../constants/tables/orderWidgetParkings";

import name from "./name";
import driversAmount from "./driversAmount";
import aliases from "./aliases";
import company from "./company";
import taxiService from "./taxiService";

export interface Column {
	render: (options: Column.Options) => ReactNode;
	label: string | string[];
}

export declare namespace Column {
	interface Options {
		width?: number;
		language: Language;
		onResize?: (width: number, columnId: ColumnId) => void;
	}
}

const createLabel2 = (id: ColumnId, tPath: string): [string, string] => [
	`${translationTablePath2}${tPath}`,
	getDefaultColumnLabelCellHelpers(id),
];

const createLabel = (id: ColumnId, tPath: string): [string, string] => [
	`${translationTablePath}${tPath}`,
	getDefaultColumnLabelCellHelpers(id),
];

export const columns: Record<ColumnId, Column> = {
	[ColumnId.Name]: {
		render: name,
		label: createLabel(ColumnId.Name, "str150"),
	},
	[ColumnId.DriversAmount]: {
		render: driversAmount,
		label: createLabel(ColumnId.DriversAmount, "str151"),
	},
	[ColumnId.Aliases]: {
		render: aliases,
		label: createLabel(ColumnId.Aliases, "str152"),
	},
	[ColumnId.Company]: {
		render: company,
		label: createLabel2(ColumnId.Company, "str154"),
	},
	[ColumnId.TaxiService]: {
		render: taxiService,
		label: createLabel2(ColumnId.TaxiService, "str155"),
	},
};

export const defaultColumnIds = defaultColumns;

export const disabledColumnsIds = [];

export { ColumnId };

export default columns;
